// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DG4Q2","footer":"styles_footer__3M3Nb"};